export default {"src":"/_next/static/media/linkedin-icon.944eef5c.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};